import { useContextSelector } from "use-context-selector";

import { IStore, StoreContext } from "../store-context";
import { IComments, IGeneralComments, ISpecificGroups } from "../types";

export const useCommentsSelector = (): IComments =>
  useContextSelector(StoreContext, (store: IStore) => {
    return store.comments;
  });

export const useGeneralCommentsSelector = (): IGeneralComments =>
  useContextSelector(StoreContext, (store: IStore) => store.comments.general);

export const useSpecificCommentsSelector = (): ISpecificGroups =>
  useContextSelector(StoreContext, (store: IStore) => store.comments.specific);

export const useGetCommentSelector = (
  uuid: string
): IGeneralComments | undefined =>
  useContextSelector(
    StoreContext,
    (store: IStore) => store.comments.specific[uuid]?.comments
  );

export const useGeneralLoadingSelector = (): boolean =>
  useContextSelector(
    StoreContext,
    (store: IStore) => store.comments.generalLoading
  );

export const useSpecificLoadingSelector = (): boolean =>
  useContextSelector(
    StoreContext,
    (store: IStore) => store.comments.specificLoading
  );
